// extracted by mini-css-extract-plugin
export default {"sidebar":"InsertStudentsSidebar_sidebar__OhD0w","open":"InsertStudentsSidebar_open__4HMVo"};